<template>
  <tab-item-template>
    <template #toolbar-items>
      <el-tooltip placement="bottom" content="プロセス手順定義追加" v-if="isEditable">
        <v-btn icon @click="openCreateDialog">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </el-tooltip>
      <v-spacer/>
      <toolbar-inline>
        <v-text-field
            v-model="searchText"
            clearable
            placeholder="検索"/>
      </toolbar-inline>
    </template>

    <draggable-el-table
        :value="processOperationsViewFiltered"
        @end="handleDragEnd">
      <el-table
          class="no-padding"
          row-key="id"
          :data="processOperationsViewFiltered"
          :height="tabItemBounds.height"
          border>
        <el-table-column
            align="center"
            width="25"
            v-if="isEditable"
            key="handle">
          <v-icon class="handle">mdi-menu</v-icon>
        </el-table-column>
        <el-table-column
            width="50"
            align="center"
            prop="index"
            label="追番"
            key="index">
        </el-table-column>
        <el-table-column
            min-width="50"
            label="プロセス構成モデル"
            key="name">
          <template #default="{row}">
            <table-inline>
              <model-select
                  :value="row.processComponentModelId"
                  :items="processComponentModels"
                  :readonly="!isEditable"
                  @change="handleProcessComponentModelIdChange(row, $event)"
                  loose-menu-width>
                <template #item="{item, on, attrs}">
                  <v-list-item v-bind="attrs" v-on="on" class="show-label-on-hover process-component-model-menu-item">
                    <v-col class="name">
                      <menu-inline>
                        <text-field-like
                            label="名称"
                            :value="item.name"
                            :value-hds-id="item.id">
                        </text-field-like>
                      </menu-inline>
                    </v-col>
                    <v-col>
                      <menu-inline>
                        <text-field-like
                            label="説明"
                            :value="item.description"
                            placeholder="未設定"
                            multi-line>
                        </text-field-like>
                      </menu-inline>
                    </v-col>
                  </v-list-item>
                </template>
              </model-select>
            </table-inline>
          </template>
        </el-table-column>
        <el-table-column
            width="100"
            label="区分"
            key="operationType">
          <template #default="{row}">
            <table-inline>
              <v-select
                  v-model="row.operationType"
                  :items="operationTypes"
                  :readonly="!isEditable"
                  @change="handleProcessOperationChange(row)">
              </v-select>
            </table-inline>
          </template>
        </el-table-column>
        <el-table-column
            class-name="description"
            label="説明"
            key="description">
          <template #default="{row}">
            <table-inline>
              <description-input
                  v-model="row.description"
                  :readonly="!isEditable"
                  @change="handleProcessOperationChange(row)">
              </description-input>
            </table-inline>
          </template>
        </el-table-column>
        <el-table-column
            label="対象データ構成モデル"
            key="dataComponentModel">
          <template #default="{row}">
            <table-inline>
              <model-select
                  v-model="row.dataComponentModelId"
                  :items="entities.dataComponentModel.find()"
                  :clearable="isEditable"
                  :readonly="!isEditable"
                  @change="handleProcessOperationChange(row)"
                  loose-menu-width>
                <template #prepend-inner v-if="!row.dataComponentModel">
                  <el-tooltip content="対象データ構成モデルを設定して下さい" placement="bottom">
                    <error-icon level="warn" class="ml-2" small style="margin: 6px 0;"></error-icon>
                  </el-tooltip>
                </template>
                <template #item="{item, on, attrs}">
                  <v-list-item v-bind="attrs" v-on="on" class="show-label-on-hover data-component-model-menu-item">
                    <v-col class="name">
                      <menu-inline>
                        <text-field-like
                            label="名称"
                            :value="item.name"
                            :value-hds-id="item.id">
                        </text-field-like>
                      </menu-inline>
                    </v-col>
                    <v-col>
                      <menu-inline>
                        <text-field-like
                            label="説明"
                            :value="item.description"
                            placeholder="未設定"
                            multi-line>
                        </text-field-like>
                      </menu-inline>
                    </v-col>
                  </v-list-item>
                </template>
              </model-select>
            </table-inline>
          </template>
        </el-table-column>
        <el-table-column
            width="40"
            align="center"
            fixed="right">
          <template #default="{row}">
            <icon-btns>
              <icon-btn
                  v-if="isEditable"
                  type="delete"
                  @click="openDeleteDialog(row)">
              </icon-btn>
            </icon-btns>
          </template>
        </el-table-column>
      </el-table>
    </draggable-el-table>

    <!-- プロセス手順定義作成ダイアログ -->
    <simple-dialog
        v-model="dialogCreate"
        title-text="プロセス手順定義作成"
        @close="closeCreateDialog">
      <v-row>
        <v-col cols="4">
          <model-select
              autofocus
              v-model="dialogCreate.processComponentModelId"
              :items="processComponentModels"
              label="プロセス構成モデル"
              hint="後から変更が可能です"
              :rules="[v => !!v || 'プロセス構成モデルが必要です']"
              loose-menu-width>
            <template #item="{item, on, attrs}">
              <v-list-item v-bind="attrs" v-on="on" class="show-label-on-hover process-component-model-menu-item">
                <v-col class="name">
                  <menu-inline>
                    <text-field-like
                        label="名称"
                        :value="item.name"
                        :value-hds-id="item.id">
                    </text-field-like>
                  </menu-inline>
                </v-col>
                <v-col>
                  <menu-inline>
                    <text-field-like
                        label="説明"
                        :value="item.description"
                        placeholder="未設定"
                        multi-line>
                    </text-field-like>
                  </menu-inline>
                </v-col>
              </v-list-item>
            </template>
          </model-select>
        </v-col>
        <v-col cols="4">
          <v-select
              v-model="dialogCreate.operationType"
              :items="operationTypes"
              label="区分"
              hint="後から変更が可能です"
              :rules="[v => !!v || '区分が必要です']">
          </v-select>
        </v-col>
        <v-col cols="4">
          <model-select
              v-model="dialogCreate.dataComponentModelId"
              :items="entities.dataComponentModel.find()"
              label="対象データ構成モデル"
              hint="後から変更が可能です"
              loose-menu-width>
            <template #item="{item, on, attrs}">
              <v-list-item v-bind="attrs" v-on="on" class="show-label-on-hover data-component-model-menu-item">
                <v-col class="name">
                  <menu-inline>
                    <text-field-like
                        label="名称"
                        :value="item.name"
                        :value-hds-id="item.id">
                    </text-field-like>
                  </menu-inline>
                </v-col>
                <v-col>
                  <menu-inline>
                    <text-field-like
                        label="説明"
                        :value="item.description"
                        placeholder="未設定"
                        multi-line>
                    </text-field-like>
                  </menu-inline>
                </v-col>
              </v-list-item>
            </template>
          </model-select>
        </v-col>
        <v-col cols="12">
          <v-textarea
              v-model="dialogCreate.description"
              label="説明"
              messages="複数行入力可"
              rows="1"
              auto-grow/>
        </v-col>
      </v-row>
    </simple-dialog>

    <!-- プロセス手順定義削除ダイアログ -->
    <simple-dialog
        v-model="dialogDelete"
        title-text="プロセス手順定義削除"
        title-color="delete"
        apply-text="削除"
        header-text="以下のプロセス手順定義を削除します。本当によろしいですか？"
        @close="closeDeleteDialog">
      <v-row>
        <v-col cols="4">
          <model-select
              v-model="dialogDelete.processComponentModelId"
              :items="processComponentModels"
              label="プロセス構成モデル"
              readonly>
          </model-select>
        </v-col>
        <v-col cols="4">
          <v-select
              v-model="dialogDelete.operationType"
              :items="operationTypes"
              label="区分"
              readonly>
          </v-select>
        </v-col>
        <v-col cols="4">
          <model-select
              v-model="dialogDelete.dataComponentModelId"
              :items="entities.dataComponentModel.find()"
              :placeholder="!!dialogDelete.dataComponentModelId ? '' : '選択なし'"
              label="対象データ構成モデル"
              readonly>
          </model-select>
        </v-col>
        <v-col cols="12">
          <text-field-like
              v-model="dialogDelete.description"
              label="説明"
              placeholder="未設定"
              multi-line/>
        </v-col>
      </v-row>
    </simple-dialog>
  </tab-item-template>
</template>

<script>
import PathInfoMixin from "@/router/PathInfoMixin";
import SimpleDialog from "@/components/organisms/SimpleDialog.vue";
import DraggableElTable from "@/components/atoms/DraggableElTable.vue";
import TableInline from "@/components/atoms/TableInline.vue";
import ModelSelect from "@/components/molecules/ModelSelect.vue";
import DescriptionInput from "@/components/molecules/DescriptionInput.vue";
import {mapActions, mapGetters, mapMutations} from "vuex";
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import {generateTemporaryID} from "@/store/modules/hds";
import IconBtns from "@/components/molecules/IconBtns";
import IconBtn from "@/components/molecules/IconBtn.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import ToolbarInline from "@/components/atoms/ToolbarInline.vue";
import MenuInline from "@/components/atoms/MenuInline.vue";
import {PROCESS_OPERATION_OPERATION_TYPES} from "@/constants";
import ErrorIcon from "@/components/molecules/ErrorIcon.vue";
import {noop} from "@/utils/TypeUtil";

export default {
  name: 'process-operation-list',
  components: {
    ErrorIcon,
    MenuInline,
    ToolbarInline,
    TextFieldLike,
    IconBtn,
    IconBtns,
    TabItemTemplate,
    DescriptionInput, ModelSelect, TableInline, SimpleDialog, DraggableElTable
  },
  mixins: [PathInfoMixin],
  props: {
    dictionary: Object,
    serviceComponentModel: Object,
    selectedDataComponentModel: Object,
  },
  inject: [
    "tabItemBounds"
  ],
  data() {
    return {
      searchText: null,
      dialogCreate: false,
      dialogDelete: false,
      operationTypes: Object.entries(PROCESS_OPERATION_OPERATION_TYPES).map(([value, text]) => ({value, text})),
      processOperationHook: 0,
    };
  },
  computed: {
    ...mapGetters({
      entities: 'hds/entities'
    }),
    processComponentModels() {
      return this.entities.processComponentModel
          .find({serviceComponentModelId: this.serviceComponentModel.id});
    },
    processOperations() {
      noop(this.processOperationHook);
      const _e = this.entities;
      return _e.processOperation
          .find({serviceComponentModelId: this.serviceComponentModel.id})
          .sort((a, b) => a.index - b.index);
    },
    processOperationsView() {
      const _e = this.entities;
      return this.processOperations
          .map(po => ({
            ...po,
            processComponent: _e.processComponentModel.findOne({id: po.processComponentModelId}),
            dataComponentModel: _e.dataComponentModel.findOne({id: po.dataComponentModelId})
          }));
    },
    processOperationsViewFiltered() {
      if (this.searchText) {
        return this.processOperationsView
            .filter(d =>
                d.processOperation.description.indexOf(this.searchText) !== -1 ||
                d.processComponent.name.indexOf(this.searchText) !== -1 ||
                d.dataComponentModel.name.indexOf(this.searchText) !== -1);
      }
      return this.processOperationsView;
    },
  },
  methods: {
    ...mapMutations({
      showSnackbar: 'showSnackbar',
    }),
    handleProcessComponentModelIdChange(processOperation, newProcessComponentModelId) {
      this.updateProcessOperation(processOperation);
      processOperation.processComponentModelId = newProcessComponentModelId;
      this.handleProcessOperationChange(processOperation);
    },
    handleProcessOperationChange(processOperation) {
      this.updateProcessOperation(processOperation);
      this.$emit('dirty');
    },
    updateProcessOperation(processOperation) {
      const _e = this.entities;
      const pcm = _e.processComponentModel.findOne({id: processOperation.processComponentModelId});
      if (pcm) {
        _e.processComponentModel.update(pcm);
      } else {
        processOperation.processComponentModelId = null;
      }
      _e.processOperation.update(processOperation);
      this.processOperationHook++;
      this.updateErrorLevel();
    },
    updateErrorLevel() {
      this.$emit('update-error-level')
    },
    openCreateDialog() {
      this.dialogCreate = {
        id: generateTemporaryID(),
        serviceComponentModelId: this.serviceComponentModel.id,
        dataComponentModelId: this.selectedDataComponentModel?.id ?? null,
        description: '',
        index: this.processOperations
            .map(p => p.index)
            .reduce((acc, current) => Math.max(acc, current), 0) + 1
      };
    },
    closeCreateDialog(apply) {
      const _e = this.entities;
      if (apply) {
        const newProcessOperation = this.dialogCreate;
        _e.processOperation.insert(newProcessOperation);
        this.updateProcessOperation(newProcessOperation);
        this.$emit('dirty');
        this.$emit('update-error-level');
      }
      this.dialogCreate = false;
    },
    openDeleteDialog(row) {
      this.dialogDelete = row;
    },
    closeDeleteDialog(apply) {
      if (apply) {
        const deleteProcessOperation = this.dialogDelete;
        const index = deleteProcessOperation.index;
        for (let row of this.processOperations) {
          if (row.index > index) {
            row.index--;
            this.updateProcessOperation(row);
          }
        }
        this.updateProcessOperation(deleteProcessOperation);
        this.entities.processOperation.remove(deleteProcessOperation);
        this.showSnackbar({
          message: `プロセス手順定義が削除されました`
        });
        this.$emit('dirty');
        this.$emit('update-error-level');
      }
      this.dialogDelete = false;
    },
    handleDragEnd(e) {
      const _e = this.entities;
      const processComps = this.processOperations;
      const oldIdx = e.oldDraggableIndex;
      const newIdx = e.newDraggableIndex;
      if (oldIdx < newIdx) {
        for (let i = oldIdx + 1; i <= newIdx; i++) {
          const processOpe = processComps[i];
          processOpe.index--;
          this.updateProcessOperation(processOpe);
        }
        const processOpe = processComps[oldIdx];
        processOpe.index = newIdx + 1;
        _e.processOperation.update(processOpe);
        this.$emit('dirty');
      } else if (newIdx < oldIdx) {
        for (let i = newIdx; i < oldIdx; i++) {
          const processOpe = processComps[i];
          processOpe.index++;
          this.updateProcessOperation(processOpe);
        }
        const processOpe = processComps[oldIdx];
        processOpe.index = newIdx + 1;
        this.updateProcessOperation(processOpe);
        this.$emit('dirty');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.data-component-model-menu-item,
.process-component-model-menu-item {
  max-width: 800px;
  min-width: 500px;
}

.col.name {
  max-width: 200px;
}
</style>
